import { Injectable, Injector, Type } from '@angular/core';
import { IEffect } from './effect.interface';
import { DeletableEffectSources } from './deletable-effect-sources';
import { EffectsRegistrationService } from './effects-registration.service';
import { FactoryEffectsFnMap } from '../../constants/effects-list';

/**
 * This service attaches Effects - plug-in behaviours - to order-workflow forms via dependency injection.
 * It might have other uses.
 */
@Injectable()
export class DynamicEffectsRegistratorService {
  constructor(
    private sources: DeletableEffectSources,
    private injector: Injector,
    private effectsRegistrationService: EffectsRegistrationService,
  ) {
    this.effectsRegistrationService.clearEffectsRegistered();
  }

  /**
   * If you need register array of effects
   *
   * @param {Type<IEffect>[]} effectTypes
   */
  public registerEffectsByType(effectTypes: Type<IEffect>[]): void {
    const effectInstances = effectTypes
      .map((effectType) => {
        const effectFactory = FactoryEffectsFnMap.get(effectType);
        if (!!effectFactory) {
          return effectFactory(this.injector);
        }
        const instance = this.injector.get<IEffect>(effectType, null);
        if (!instance) {
          // TODO: error-handling might be a good idea, especially error-reporting.
          throw new Error(`You didn't probably register this effect into providers ` + effectType);
        }
        return instance;
      })
      .filter((effectType) => {
        return effectType !== null;
      });

    effectInstances.forEach((instance) => {
      this.registerEffect(instance);
    });
  }

  /**
   * If you need register one single effect
   *
   * @param {Type<IEffect>} effectType
   */
  public registerEffectByType(effectType: Type<IEffect>) {
    this.registerEffect(this.injector.get<IEffect>(effectType));
  }

  public registerEffect(effectInstance: any) {
    this.effectsRegistrationService.addEffects(effectInstance);
    this.sources.addEffects(effectInstance);
  }

  /**
   * @param {Type<IEffect>} effectTypes
   */
  public removeEffectByTypes(effectTypes: Type<IEffect>[]) {
    this.effectsRegistrationService.deleteEffects(effectTypes);
    this.sources.deleteEffects(effectTypes);
  }
}
